<template>
  <div class="home">
    <img src="../assets/images/pc_bg.png" class="w-full hidden md:block" alt="">
    <img src="../assets/images/mb_bg.png" class="w-full md:hidden" alt="">
    <img src="../assets/images/arrow.png"  class="shake-element -mt-10 mx-auto md:-mt-16 md:absolute md:right-[15%]" width="35" alt="">
    <div class="flex items-center justify-center col pt-3 my-5 md:my-8 flex-col md:flex-row">
      <img src="../assets/images/btn_1.png"  class="cursor-pointer mb-2 md:mb-0 mb:mt-0 h-[60px]  md:mr-3" @click="getTicket('dailyget', 1)" alt="">
      <img src="../assets/images/btn_2.png" class="cursor-pointer mb-2 md:mb-0 h-[60px] md:mr-3" alt="" @click="checkInf('buy', {})" >
      <img src="../assets/images/btn_3.png" @click="scrollToTarget"  class="cursor-pointer md:mb-0 h-[60px]" alt="">
    </div>
    <button class="text-white cursor-pointer"  @click="logout" v-if="hasInfParam"><u>登出</u></button>
    <div class="p-3 max-w-[900px] md:mx-auto">
      <div class="grid grid-cols-2 gap-2" ref="targetElement">
        <div class="bg-white p-1 box-item" v-for="(item, index) in rewardList" :key="index" :class="{'col-span-2 mx-auto': index === 0||index === 5,'w-[70%]': index === 0||index === 5}">
          <div class="w-full">
            <img :src="require(`../assets/images/reward_${item.id}.png`)" class="w-full md:hidden" alt="">
            <img :src="require(`../assets/images/reward_pc_${item.id}.png`)" class="w-full hidden md:block" alt="">
            <!-- <img :src="require(`../assets/images/reward_77.jpg`)" class="w-full md:hidden" alt=""> -->
            <!-- <img :src="require(`../assets/images/reward_pc_77.jpg`)" class="w-full hidden md:block" alt=""> -->
            <p class="my-2 text-center font-bold">{{ item.box_name }}</p>
          </div>
          <div class="w-full">
            <div class="md:flex justify-around">
              <div class="flex items-center justify-between text-sm text-[#868686]">
                <p>您已投入的張數 </p>
                <p class="ml-1">{{ item.mycount || 0 }}<span class="ml-1">張</span></p>
              </div>
              <div class="flex items-center justify-between text-sm text-[#868686]">
                <p>目前投入總張數 </p>
                <p class="ml-1">{{ item.total_count }}<span class="ml-1">張</span></p>
              </div>
            </div>
            <div class="w-full cursor-pointer mt-3 bg-[#f4421a] py-1 text-white font-bold md:text-lg" @click="checkInf('box',item)">投入抽獎券</div>
            <!-- <img src="../assets/images/box_btn.png" @click="boxId = item.id, showModel = true" class="cursor-pointer md:hidden w-full mt-3" alt=""> -->
            <!-- <img src="../assets/images/box_btn_pc.png" @click="boxId = item.id, showModel = true" class="cursor-pointer hidden md:block w-full mt-3" alt=""> -->
          </div>
        </div>
      </div>
    </div>
    <img src="../assets/images/btn_side.png" @click="showNoticeModel = true" width="10%" class="cursor-pointer max-w-14 fixed right-0 bottom-10" alt="">
    <div class="modal" v-if="showModel || buyTicketModel || msgModel || infModel">
      <div class="modal-content shadow p-5 text-[#868686]" v-if="showModel">
        <p class="my-3">您確定要兌換嗎?</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-zinc-400 py-2 w-1/3 mr-3 cursor-pointer" @click="showModel = false">取消</button>
          <button class="rounded-full bg-[#fcc02e]  py-2 w-1/3 cursor-pointer" @click="box()">確認</button>
        </div>
      </div>
      <div class="modal-content shadow p-5 text-[#868686]" v-if="buyTicketModel">
        <p class="my-3">您現有的點數為: {{enableAiCoin}} 點</p>
        <p class="my-3">目前剩餘抽獎券: {{lastTickets}} 張</p>
        <p class="my-3">您可購買的上限為: {{parseInt(enableAiCoin/10)}} 張</p>
        <div class="my-3 flex items-center justify-center">請輸入購買張數:<input type="number"  min="1" v-model="tickets" class="text-sm w-20 border text-right mx-1 rounded-lg outline-2 outline-blue-500/50 px-1">張</div>
        <p v-if="error !== ''" class="text-xs text-red-500 my-2">{{ error }}</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-zinc-400 py-2 w-1/3 mr-3 cursor-pointer" @click="buyTicketModel = false">取消</button>
          <button class="rounded-full bg-[#fcc02e]  py-2 w-1/3 cursor-pointer" @click="getTicket('add', tickets)">確認</button>
        </div>
      </div>
      <div class="modal-content shadow p-5 text-[#868686]" v-if="msgModel">
        <p class="my-3">{{ msg }}</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-[#fcc02e]  py-2 w-1/3 cursor-pointer" @click="closeMsgModel()">確認</button>
        </div>
      </div>
      <div class="modal-content shadow p-5 text-[#868686]" v-if="infModel">
        <p class="my-3">若想參加抽獎活動，<br>請點選登入領取抽獎券！</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-zinc-400 py-2 w-1/3 mr-3 cursor-pointer" @click="infModel = false">再看一下</button>
          <button class="rounded-full bg-[#fcc02e]  py-2 w-1/3 cursor-pointer" @click="goToLogin()">登入參加</button>
        </div>
      </div>
    </div>
    <div class="modal" v-if="showNoticeModel">
      <div class="relative max-w-[900px]">
        <img src="../assets/images/btn_close.png" @click="showNoticeModel = false" class="absolute right-5 top-0 max-w-[50px] cursor-pointer" width="35px" alt="">
        <!-- <img class="relative translate-y-2/4 m-auto  z-50 max-w-[400px]" src="../assets/images/title.png" width="70%" alt=""> -->
        <div class="relative translate-y-2/4 m-auto rounded-sm  bg-[#62adaf] py-2 text-lg text-nowrap w-[70%] text-white font-bold z-50 max-w-[400px]">
          第024期抽獎趣活動說明
        </div>
        <div class="relative notice max-h-[80vh] w-[90%] mx-auto overflow-y-auto bg-white">
          <div class="text-left pt-10 pb-6 px-3 md:px-10 text-sm text-[#868686]">
            <p>一、活動說明</p>
            <br>
            <p>第 024 期 端午抽獎趣 </p>
            <p>即日起APP專屬好運抽獎活動，每日參加活動即可獲得免費抽獎券乙張！有機會獲得各式好禮超值好康 不容錯過! </p>
            <br>
            <p>活動時間 ：2026/06/01- 2026/06/30  </p>
            <p>活動細項說明:</p>
            <br>
            <ul>
              <li>●凡 UUPON 會員即可參加抽獎活動，每次投入抽獎券不限張數。</li>
              <li>●會員每日進入活動頁面可獲得免費抽獎券乙張。</li>
              <li>●抽獎券亦可使用點數兌換取得。</li>
              <li>●抽獎券可投入各式好禮抽獎箱。</li>
              <li>●獎項將於 2026/07/10 號 抽出並公布於UUPON Facebook粉絲專頁。</li>
              <li>●獎品將於隔月月底前抽獎完成後存入您的帳戶中。</li>
              <li>●參與活動前請詳閱注意事項以維護您的權益，UUPON 保有活動變更、取消以及最終解釋等所有權。</li>
            </ul>
            <br>
            <p>二、獎項</p>
            <br>
            <p>(1) Apple Store 電子禮品卡 5,000元 （1名）</p>
            <p>(2) UUPON 2,500點 （3名）</p>
            <p>(3) UUPON 1,000點 （5名）</p>
            <p>(4) UUPON 600點 （10名）</p>
            <p>(5) 7-11 數位商品禮券 500元 （3名）</p>
            <p>(6) 全家中杯冰拿鐵10杯（10名）</p>
            <br>
            <p>三、活動注意事項</p>
            <br>
            <p>1. 參加本活動視同已認可並必須遵守 UUPON APP 使用條款、活動規則及注意事項,如有違反視同放棄,UUPON 擁有取消其兌換資格之權利。 </p>
            <p>2. 圖片僅供參考,獎品以實物為準,不得要求兌換等值的商品或現金。 </p>
            <p>3. 獎項共6項，本次抽獎券可投入抽獎箱時效至 2026/06/30 23:59。 </p>
            <p>4. 若因用戶網路狀況、裝置差異、手機設定、移轉帳號或其他變更等因素導致無法順利完成活動或獲得之獎項遗失,UUPON 將不負擔任何責任或損害賠償。 </p>
            <p>5. UUPON 點數一經扣點進行兌換商品或票券後，視同交易完成，即不接受取消交易或返還點數。 </p>
            <p>6. 獎項不得兌現、分割、出售或轉售。</p>
            <p>7. 得獎者不得要求獎項折算現金或轉讓，中獎者個人資料需與 UUPON 會員資料一致，如經查證非同一人將取消中獎資格 </p>
            <p>8. 如遇不可抗拒之天災或非人為造成之因素，點鑽整合行銷股份有限公司(UUPON)有權暫停、延期 或取消活動。  </p>
            <p>9. 如有未盡事宜，悉依相關規定或解釋，點鑽整合行銷股份有限公司(UUPON)得隨時補充公告說明，並保有本次活動最終解釋權。</p>
            <br>
            <p>四、抽獎獎項及領獎注意事項</p>
            <br>
            <p>1.024期 端午抽獎趣獎項 :</p>
            <ul>
              <li>(1) Apple Store 電子禮品卡 5,000元 （1名）</li>
              <li>(2) UUPON 2,500點 （3名）</li>
              <li>(3) UUPON 1,000點 （5名）</li>
              <li>(4) UUPON 600點 （10名）</li>
              <li>(5) 7-11 數位商品禮券 500元 （3名）</li>
              <li>(6) 全家中杯冰拿鐵10杯（10名）</li>
            </ul>
            <p>2.獎品價值超過新台幣 1,000 元(含)以上者，將寄發中獎通知函;中獎者請務必 於 2026/07/17 前完善會員個人資料(姓名、電話、地址、Email)並且需正確無誤(姓名及地址需與身 分證一致)，因資料不完善，致使 UUPON 無法聯繫，將視同放棄中獎資格。</p>
            <p>3.領獎時需依法繳納稅金，依中華民國稅法規定，得獎者若為中華民國境內居住之個人:</p>
            <ul>
              <li>(1)中獎金額或獎品價值超過新台幣 1,000 元(含)以上者，需先繳交身分證正反面影本供報稅使用，始可領獎，年度報稅時將併入個人綜合所得稅申報。</li>
              <li>(2)得獎者若非中華民國境內居住之個人:不論得獎者所得之金額，均需依法繳交 20%機會中獎所得稅金，始可領獎。  </li>
              <li>(3)得獎者若為未成年人，應檢附戶籍謄本，並提出法定代理人同意書。</li>
              <li>(4) 若得獎者不願先行繳納本項依稅法規定須先扣繳之稅金，或未依上述說明辦理領獎手續(含逾期未 領取獎項)，視同放棄中獎資格，且不得異議。</li>
            </ul>
          </div>
          <!-- <img src="../assets/images/triangle.svg" width="40%" class="md:hidden" alt=""> -->
          <!-- <img src="../assets/images/triangle_pc.svg" width="40%" class="hidden md:block" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import axios from 'axios'
import CryptoJS from 'crypto-js'
import axios from 'axios'

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      encryptedString: '',
      key: '1234567890123456',
      decryptedWord: null,
      encryptedBase64: '',
      decryptedData: null,
      rewardList: [],
      showModel: false,
      showNoticeModel: false,
      buyTicketModel: false,
      kn: '',
      openId: '',
      enableAiCoin: 0,
      tickets: 0,
      msgModel: false,
      msg: '',
      goToIndex: false,
      error: '',
      boxId: '',
      lastTickets: 0,
      hasInfParam: false,
      infModel: false
    }
  },
  created () {
    const url = window.location.href
    const startIndex = url.indexOf('inf=')
    if (startIndex !== -1) {
      const valueStartIndex = startIndex + 4
      let endIndex = url.indexOf('&', valueStartIndex)
      if (endIndex === -1) {
        endIndex = url.length
      }
      const infValue = url.substring(valueStartIndex, endIndex)
      this.inf = infValue
    } else {
      console.log('URL 中没有 inf 参数')
    }
    // 先解密inf
    this.decryptData(this.inf)
    // 取kn字串
    // this.kn = '0886000000000000240600'
    if (this.decryptedData) {
      this.kn = this.decryptedData.kn
      this.openId = this.decryptedData.openId
      this.enableAiCoin = this.decryptedData.enableAiCoin
      this.lastTickets = this.decryptedData.tickets
      const newArray = { kn: this.kn }
      // 將kn字串再加密
      this.encryptData(newArray)
      this.hasInfParam = true
    } else {
      this.hasInfParam = false
    }
    this.getList()
  },
  mounted () {
  },
  methods: {
    checkInf (type, item) {
      if (!this.hasInfParam) {
        this.infModel = true
        return
      }
      if (type === 'box') {
        this.boxId = item.id
        this.showModel = true
      } else if (type === 'buy') {
        this.buyTicketModel = true
        this.tickets = 0
        this.error = ''
      }
    },
    goToLogin () {
      location.href = 'https://boxapi.uupon.com/2026024/'
    },
    logout () {
      location.href = 'https://boxapi.uupon.com/2026024/logout'
    },
    // 解密
    decryptData (data) {
      try {
        const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
        const encryptedWordArray = CryptoJS.enc.Base64.parse(data)
        // 使用 AES-128-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: encryptedWordArray },
          keyWordArray,
          { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        )
        this.decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
      } catch (error) {
        this.decryptedData = null
      }
    },
    // 加密
    encryptData (data) {
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.encryptedBase64 = encryptedBase64
    },
    getTicket (act, tickets) {
      if (!this.hasInfParam) {
        this.infModel = true
        return
      }
      if (act === 'add' && tickets > parseInt(this.enableAiCoin / 10)) {
        this.error = '*超過可購買數量，請重新輸入'
        return
      } else if (act === 'add' && tickets === 0) {
        this.error = '*請先輸入購買數量'
        return
      } else {
        this.error = ''
      }
      const data = {
        openId: this.openId,
        act: act,
        tickets: act === 'add' ? tickets : 1,
        kn: this.kn
      }
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const inf = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      axios({
        method: 'get',
        url: `https://boxapi.uupon.com/2026024/getTicket?inf=${inf}`
      }).then((response) => {
        this.msg = response.data.errno
        this.buyTicketModel = false
        this.msgModel = true
        this.lastTickets = Number(response.data.tickets)
        if (act === 'add') {
          this.enableAiCoin = response.data.aiCoin
        }
        this.goToIndex = Boolean(response.data.code === 2000)
      })
    },
    closeMsgModel () {
      this.msgModel = false
    },
    box () {
      if (!this.hasInfParam) {
        this.infModel = true
        return
      }
      const data = {
        openId: this.openId,
        box_id: this.boxId,
        kn: this.kn
      }
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const inf = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      fetch(`https://boxapi.uupon.com/2026024/putTicket?inf=${inf}`, {
        method: 'POST'
      }).then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      }).then(data => {
        this.msg = data.msg
        this.showModel = false
        this.msgModel = true
        this.getList()
      }).catch(error => {
        console.error(error)
      })
    },
    async getList () {
      // 有帶inf時取得會員投票的紀錄
      await axios({
        method: 'get',
        url: 'https://boxapi.uupon.com/2026024/BoxList'
      }).then((response) => {
        this.rewardList = response.data.filter(v => v.state === '0')
      })
      if (this.hasInfParam) {
        axios({
          method: 'get',
          url: `https://boxapi.uupon.com/2026024/BoxList?inf=${this.encryptedBase64}`
        }).then((response) => {
          if (response.data.length > 0) {
            if (response.data[0].kaiin_no !== '' || response.data.length === 0) {
              this.userList = response.data
              for (let i = 0; i < this.rewardList.length; i++) {
                for (let j = 0; j < this.userList.length; j++) {
                  if (this.userList[j].id === this.rewardList[i].id) {
                    this.rewardList[i].mycount = this.userList[j].mycount
                  }
                }
              }
            } else {
              location.href = 'https://boxapi.uupon.com/2026024/'
            }
          }
        })
      }
    },
    scrollToTarget () {
      const targetElement = this.$refs.targetElement
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss" scoped>
body {
  font-family: 'Inter', sans-serif;
}
.home{
  background-color: #b9e4e5 !important;
  // background-image: url('../assets/images/bg_mb.jpg');
  // background-repeat: no-repeat;
  // background-position: top;
  // background-size: contain;
  width: 100%;
  .box-item{
    // background-image: url('../assets/images/box_bg.png') ;
    background-position: left bottom;
    background-size: 90%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .modal{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-content{
      max-width: 450px;
      background: #ffffff;
      width: 90%;
      border-radius: 12px;
      margin: auto;
    }
    .notice{
      border: 2px solid #b9e4e5;
    }
  }
}
@media only screen and (min-width: 768px) {
  .home{
    background-color: #b9e4e5 !important;
    // background-repeat: no-repeat !important;
    // background-position: 0px 350px !important;
    // background-size: contain !important;
    // background: url('../assets/images/bg_pc.jpg');
    width: 100%;
    .box-item{
      // background-image: url('../assets/images/box_bg_pc.png') ;
      // background-size: 70%;
    }
    .modal{
      .notice{
        border: 4px solid #b9e4e5;
      }
    }
  }
}
</style>
